import React, { Component } from 'react';
import Main from './components/MainComponent';
import './App.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import ScrollPositionContext from './contexts/ScrollPositionContext';
import { ConfigureStore } from './redux/configureStore';

const { store, persistor } = ConfigureStore();

// Enhanced loading component
const Loading = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '24px',
        fontFamily: 'sans-serif',
        backgroundColor: '#f8f9fa'
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '20px', color: '#333' }}>
          Loading saved state...
        </div>
        <div className='spinner-border text-primary' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    </div>
  );
};

class App extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      scrollPosition: 0,
      isRehydrated: false // Track rehydration status
    };
  }

  componentDidMount () {
    // Ensure persistor has finished rehydrating
    persistor.persist();
  }

  setScrollPosition = position => {
    this.setState({ scrollPosition: position });
  };

  render () {
    return (
      <Provider store={store}>
        <PersistGate
          loading={<Loading />}
          persistor={persistor}
          onBeforeLift={() => {
            // This runs AFTER rehydration completes
            console.log('✅ Rehydration complete, state restored');
          }}
        >
          <BrowserRouter>
            <ScrollPositionContext.Provider
              value={{
                scrollPosition: this.state.scrollPosition,
                setScrollPosition: this.setScrollPosition
              }}
            >
              <div>
                <Main />
              </div>
            </ScrollPositionContext.Provider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
